import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Navbar() {
  return <nav className="sticky top-0 z-50 w-full bg-white border-b border-slate-200 shadow-sm" data-id="element-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-101">
        <div className="flex justify-between items-center h-20" data-id="element-102">
          <div className="flex items-center gap-2" data-id="element-103">
            <ShieldCheck className="w-8 h-8 text-navy-900" data-id="element-104" />
            <span className="font-bold text-xl md:text-2xl text-navy-900 tracking-tight" data-id="element-105">
              Arquitecto de Crédito <span className="text-gold-500" data-id="element-106">USA</span>
            </span>
          </div>
          <div data-id="element-107">
            <a href="https://www.academyebooks.com/cart/46458086424737:1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-sm md:text-base font-bold rounded-md text-navy-900 bg-gold-500 hover:bg-gold-400 transition-colors shadow-sm" data-id="element-108">
              Comprar Ahora
            </a>
          </div>
        </div>
      </div>
    </nav>;
}